import { Calendar } from '@/components/icons'
import moment from 'moment'
import { forwardRef } from 'react'
import ReactDatePicker, { DatePickerProps } from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'

type Props = Omit<DatePickerProps, 'selected' | 'showMonthYearDropdown'> & {
  label?: string
  labelClassName?: string
  selected: string
  error?: string
  containerClassName?: string
  iconClassName?: string
} & (
    | {
        selectsRange: true
        selectsMultiple?: never
        onChange: (
          date: [Date | null, Date | null],
          event?: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>
        ) => void
      }
    | {
        selectsRange?: never
        selectsMultiple: true
        onChange: (
          date: Date[] | null,
          event?: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>
        ) => void
      }
    | {
        selectsRange?: never
        selectsMultiple?: never
        onChange: (date: Date | null, event?: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>) => void
      }
  )

export const DatePickerInput = forwardRef<any, Props>(
  (
    {
      label,
      labelClassName,
      className,
      iconClassName,
      error,
      selected,
      wrapperClassName,
      containerClassName,
      ...props
    },
    ref
  ) => {
    return (
      <div className={`flex flex-col gap-y-2 ${containerClassName}`}>
        {label && (
          <span className={`text-white text-sm font-semibold ${labelClassName ? labelClassName : ''}`}>{label}</span>
        )}
        <div className="relative">
          <Calendar
            className={`absolute top-1/2 -translate-y-1/2 left-4 z-10 pointer-events-none text-navy-900 ${
              iconClassName ? iconClassName : ''
            }`}
          />
          <ReactDatePicker
            ref={ref}
            selected={selected ? moment(selected).toDate() : null}
            className={`rounded-full border border-navy-900 border-opacity-20 w-full text-sm
              p-3 md:p-[17px] !pl-12 focus:outline-none text-navy-900 ${className ? className : ''}`}
            wrapperClassName={`w-full ${wrapperClassName ? wrapperClassName : ''}`}
            popperClassName="z-20"
            popperPlacement="top-start"
            {...props}
          />
        </div>
        {error && <div className="text-boldOrange -mt-1 font-medium">{error}</div>}
      </div>
    )
  }
)
